import { render } from "./specialist.minimized.ic.vue?vue&type=template&id=4bb6c75c"
import script from "./specialist.minimized.ic.vue?vue&type=script&lang=js"
export * from "./specialist.minimized.ic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__